/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { DataClip } from "./DataClip";
export const DataClipResponse = core.serialization.object({
    data: DataClip,
});
